import styled from '@emotion/styled';

import { tableFormatDateTimeNG } from '../../../utils/utils';

interface TableDateTimeFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
}

const TableDateTimeFormatter: React.FC<TableDateTimeFormatterProps> = ({
  data,
  dataKey,
}) => {
  const label = data && data[dataKey ?? ''];
  return <Container>{tableFormatDateTimeNG(label)}</Container>;
};

export default TableDateTimeFormatter;

const Container = styled.div``;
